import { isSteuerIdValid } from 'validate-steuerid'
import validator from 'validator'

import type { IdValidationStrategy } from 'modules/legal_entities/lib/types'

import { GermanyIdType } from './idType'
import validatePersonalausweis from './idValidator'
import validateSsn from './ssnValidator'

class GermanyIdValidationStrategy implements IdValidationStrategy {
  constructor(
    private idType: GermanyIdType,
    private id: string,
    private idLabel: string
  ) {}
  isValid(): boolean {
    if (this.disabled()) return true

    switch (this.idType) {
      case GermanyIdType.Steueridentifikationsnummer:
        return isSteuerIdValid(this.id)
      case GermanyIdType.Sozialversicherungsnummer:
        return validateSsn(this.id)
      case GermanyIdType.Reisepass:
        return validator.isPassportNumber(this.id, 'DE')
      case GermanyIdType.Personalausweis:
        return validatePersonalausweis(this.id)
      default:
        return false
    }
  }
  errors(): string {
    if (!this.isValid()) {
      return `Invalid ${this.idLabel} number`
    }
    return ''
  }
  disabled(): boolean {
    return GermanyIdType.Reisepass == this.idType
  }
}

export default GermanyIdValidationStrategy
